interface Props {
  housingType:
    | "house"
    | "condomonium"
    | "rentalApartment"
    | "insuranceMatter"
    | undefined;
}

const RotAvdragImportantInformationSection = (props: Props) => {
  return (
    <section className="sm:p-2">
      <h4 className="text-base font-semibold sm:text-lg">
        Viktig information angående skatteavdraget
      </h4>
      <div className="flex flex-col gap-4 py-4">
        <ul className="flex list-disc flex-col gap-2 pl-6 text-sm sm:text-base">
          <li>Du ska ha skatteavdrag kvar att utnyttja</li>
        </ul>
        <p>För rot-/rutavdrag eller grön teknik gäller även:</p>
        <ul className="flex list-disc flex-col gap-2 pl-6 text-sm sm:text-base">
          <li>Du ska äga fastigheten när arbetet utförs</li>
          {props.housingType === "house" && (
            <li>Viktigt att det är rätt ifylld fastighetsbeteckning</li>
          )}
          {props.housingType === "condomonium" && (
            <li>
              Viktigt att det är rätt ifyllt organisations- och lägenhetsnummer
            </li>
          )}
        </ul>
        <p className="text-sm">
          Om skatteverket skulle neka skatteavdraget har vi rätten att fakturera
          den delen till dig som kund. Så dubbelkolla att ni har fyllt i rätt
          uppgifter. Om vi behöver ändra uppgifter, skapa en ny faktura eller
          skicka nya uppgifter till skatteverket tar vi ut en administrativ
          avgift på 250:- inkl. moms.
        </p>
      </div>
    </section>
  );
};

export default RotAvdragImportantInformationSection;
